import type { SpeedMultiplier } from '@prism/sim';

/**
 * The speeds the PLAYER may choose. The only source for the speed buttons.
 *
 * Typed as `SpeedMultiplier` rather than inferred from the literals, which is the point of
 * having it: `IDLE_SKIP_SPEED` is 16 and is deliberately not a member of that union, so
 * adding it here is a type error rather than a shipped feature.
 *
 * It matters because `GameLoop.speed` is a plain `number` — it has to be, since the idle
 * skip drives it past anything selectable to pass dead time. That widening removed the
 * type's own guarantee that nothing could set a speed the player was never offered, and
 * this list is what puts it back.
 */
export const SELECTABLE_SPEEDS: readonly SpeedMultiplier[] = [1, 2, 4];
